module.exports = __webpack_public_path__ + "img/shichangqingkuang.e9511424.png";